import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import { Block, BlockBetween, BlockHeadContent, DataTableHead, DataTableItem, DataTableRow, Icon } from '../Component';
import { formatToSentenceCase, messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import TextInput from '../../pages/components/inputs/TextInput';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { SALES_REP_UPDATE_ORDER_UNITS_API } from '../../api/api_data';
import { fail_tenant_edit_order_units, loading_tenant_edit_order_units, reset_tenant_edit_order_units, success_tenant_edit_order_units } from '../../reducers/auth_tenant/tenant_edit_order_units_Slice';
import { TENANT_UPDATE_ORDER_UNITS_ERROR_MSG, TENANT_UPDATE_ORDER_UNITS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';

const initialState = { reason: "", products: [], order_ref_number: "" };

const EditOrderItemsModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, page_data }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [confirmation_modal, setConfirmationModal] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
    // Remap Data
    const remapped_data = page_data?.order_items?.map((data) => { return { ...data, new_units: data?.units }; });

    setFormData({ ...formData, products: remapped_data, order_ref_number: page_data?.order_ref_number });
    setLoading(false);
    setError("");
  }, [isOpen, page_data]);

  const handle_unit_change_function = (new_units, id) => {
    const new_products = formData?.products?.map((data) => {

      // Calculate total value
      if (id === data?.product_id)
      {
        const unitPrice = parseFloat(data?.unit_value);
        const quantity = parseInt(new_units);
        const new_total = (unitPrice * quantity).toFixed(2);

        return { ...data, new_units, new_total_value: new_total };
      } else
      {
        return data;
      }
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      products: new_products,
    }));
  };

  const check_products_edit_length = () => {
    const filtered_products = formData?.products?.filter((data) => {
      return `${data?.units}` !== `${data?.new_units}` && parseFloat(data?.new_units)?.toFixed(2) !== "0.00" && data?.new_units;
    });

    return filtered_products;
  };

  const open_confirmation_modal = () => {
    setError("");
    setConfirmationModal(true);
  };

  const handleOrderItemsEdit = () => {
    setError("");
    dispatch(tenant_auth_actions_helper(loading_tenant_edit_order_units, success_tenant_edit_order_units, fail_tenant_edit_order_units, TENANT_UPDATE_ORDER_UNITS_ERROR_MSG, TENANT_UPDATE_ORDER_UNITS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${SALES_REP_UPDATE_ORDER_UNITS_API}`, formData));
  };

  // Listener
  const tenant_edit_order_units_listener = useSelector((state) => state.tenant_edit_order_units.tenant_edit_order_units);

  useEffect(() => {
    if (tenant_edit_order_units_listener.status !== app_consts.IDLE)
    {
      if (tenant_edit_order_units_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (tenant_edit_order_units_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(tenant_edit_order_units_listener.message);
          messageToast(tenant_edit_order_units_listener.message, app_consts.FAIL);
        } else if (tenant_edit_order_units_listener.status === app_consts.SUCCESS)
        {
          successFunction();
          closeModal();
        }
        dispatch(reset_tenant_edit_order_units());
      }
    }
  }, [tenant_edit_order_units_listener]);


  return (
    <>
      < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} fullscreen >
        <ModalHeader toggle={loading ? "" : closeModal}>Edit Order Items</ModalHeader>
        <ModalBody>
          <div className="card-inner bg-white">
            <Block>
              <BlockBetween className="mt-4">
                {
                  check_products_edit_length()?.length > 0 && (
                    <Button color="primary" size="sm" onClick={() => open_confirmation_modal(!confirmation_modal)}>
                      Confirm Changes
                    </Button>
                  )
                }
              </BlockBetween>
              <div className="nk-tb-list is-separate is-medium mb-3">
                <DataTableHead className="nk-tb-item">
                  <DataTableRow>
                    <span className="sub-text">Product</span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span className="sub-text">Color</span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span className="sub-text">Packet Size</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span className="sub-text">Current</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">Unit Value (ZMW)</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">Total Value (ZMW)</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span className="sub-text">New Units</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span className="sub-text">New Total Value (ZMW)</span>
                  </DataTableRow>
                </DataTableHead>
                {formData?.products?.length > 0
                  ? formData?.products?.map((item) => (
                    <DataTableItem key={item?.product_id}>
                      <DataTableRow size="sm">
                        <div className="user-card">
                          <div className="user-info">
                            <span className="tb-lead">
                              {item?.product?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                            </span>
                            <span>{item?.product?.category || "--"}  | {item?.product?.product_type || "--"} </span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-product">
                          <span className="tb-sub">{item?.color || "--"}</span>
                        </span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub">{item?.size || "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub">{item?.units || "0"}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub">{item?.unit_value || "0"}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub">{item?.total_value || "0"}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <Row className="g-4">
                          <TextInput
                            required
                            type="number"
                            min={1}
                            value={item?.new_units}
                            colSize="6"
                            handleChange={(e) => { handle_unit_change_function(e?.target?.value, item?.product_id); }}
                          />
                        </Row>
                      </DataTableRow>
                      <DataTableRow>
                        <Row className="g-4">
                          <TextInput
                            required
                            type="number"
                            min={1}
                            value={item?.new_total_value}
                            colSize="6"
                            disabled
                          />
                        </Row>
                      </DataTableRow>
                    </DataTableItem>
                  ))
                  : null}
              </div>
            </Block>
          </div>

          <Modal isOpen={confirmation_modal} className="modal-dialog-top">
            <ModalHeader
              toggle={() => { if (loading) { } else { setConfirmationModal(!confirmation_modal); } }}
            >
              Confirm Order Items
            </ModalHeader>
            <ModalBody>
              <p>
                Are you sure that you want to Edit these Order Products?
              </p>

              <Row className="g-4 mb-4">
                <Col size="12">
                  <div className="form-group">
                    <label className="form-label">Reason</label>
                    <textarea
                      value={formData?.reason}
                      onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                      className="form-control-xl form-control no-resize" />
                  </div>
                </Col>
              </Row>
              {error && (
                <div className="mb-3 w-100">
                  <Alert color="danger" className="alert-icon">
                    <Icon name="alert-circle" /> {error}{" "}
                  </Alert>
                </div>
              )}
            </ModalBody>
            <ModalFooter className="bg-light">
              <BlockBetween>
                <BlockHeadContent>
                  <Button className={"mx-2"} disabled={loading} onClick={() => setConfirmationModal(!confirmation_modal)} color="gray">
                    No
                  </Button>

                  <Button className={"mx-2"} disabled={loading ? loading : !formData?.reason} onClick={handleOrderItemsEdit} color="primary">
                    {loading ? <Spinner size="sm" color="light" /> : "Edit"}
                  </Button>
                </BlockHeadContent>
              </BlockBetween>
            </ ModalFooter>
          </Modal>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <div>
              <Button
                className="me-2"
                disabled={loading}
                onClick={closeModal}
                color="gray"
              >
                Close
              </Button>
              {/* Add any additional left-aligned buttons here */}
            </div>
            <div>
              {/* Right-aligned buttons would go here */}
            </div>
          </div>
        </ModalFooter>
      </Modal>

    </>
  );
};

export default EditOrderItemsModal;